import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { IAIChecklist2Model, IFiAIAssistanceResponseModel } from '@fi-shared/fi-ai-assistance/fi-ai-assistance';

@Component({
    selector: 'fi-checklist-ai-request-result',
    template: `
        <div class="ai-assistance-dialog-content-container">
          <fi-info-banner
            matIconClass="far fa-circle-exclamation"
            bannerColorClass="blue"
            [isBannerOutlined]="false"
            [bannerText]="'ai.checklist_request_success' | fiAppText"
            />
        
            <!--            checklist description todo: <b>{{ aiChecklist2.ChecklistDescription }}</b>-->
            <div class="ai-assistance-result-container">
              @for (checkpointGroup of aiChecklist2.CheckpointGroups; track checkpointGroup) {
                <fi-checklist-ai-request-result-group
                  [checkpointGroup]="checkpointGroup"
                  />
              }
            </div>
          </div>
        
          <div class="ai-assistance-dialog-actions">
            <button mat-stroked-button class="secondary-button BrandedColor" (click)="back()">
              {{ 'back' | fiAppText }}
            </button>
            <button mat-button class="primary-button BrandedBackgroundColor" (click)="addCheckpoints()">
              {{ 'checklist.add_checkpoints' | fiAppText }}
            </button>
          </div>
        `,
    styleUrl: './checklist-ai-request-result.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist-ai-request-result' },
    standalone: false,
})
export class FiChecklistAiRequestResult {
    @Input() aiChecklist2: IAIChecklist2Model;
    @Output() onBackButtonClick = new EventEmitter<void>();
    @Output() onAddCheckpointsClick = new EventEmitter<void>();

    protected back(): void {
        this.onBackButtonClick.emit();
    }

    protected addCheckpoints(): void {
        this.onAddCheckpointsClick.emit();
    }
}
